// @flow @jsx h

import { bem } from '@nrk/dh-utils'
import { h } from 'preact'
import style from './index.css'

type Props = {
  className?: string,
  position: 'top' | 'bottom'
}

function Skew (props: Props) {
  const { position } = props

  const className = `${bem(style.skew, position)}${
    props.className ? ` ${props.className}` : ''
  }`

  let polygon

  switch (position) {
    case 'top':
      polygon = <polygon points='300 0 300 10 0 10' />
      break

    case 'bottom':
      polygon = <polygon points='0 0 300 0 0 10' />
      break
  }

  return (
    <div className={className} aria-hidden='true'>
      <svg viewBox='0 0 300 10'>
        <g stroke='none' fill='none' fillRule='evenodd'>
          <g fill='currentColor'>{polygon}</g>
        </g>
      </svg>
    </div>
  )
}

export default Skew



// WEBPACK FOOTER //
// ./src/v1/components/Skew/index.js